module.exports = __webpack_public_path__ + "static/media/marketNewsIcon.d52e136c.svg";